module.exports = __webpack_public_path__ + "static/media/committed.3b4f4a0a.jpeg";